// import React, { useEffect } from "react";
// import {
//   Modal,
//   ModalHeader,
//   ModalBody,
//   ModalFooter,
//   Form,
//   FormGroup,
//   Label,
//   Input,
//   Button,
//   FormFeedback,
// } from "reactstrap";
// import { useFormik } from "formik";
// import * as Yup from "yup";

// const EditTaxModal = ({ isOpen, toggle, taxData, onSubmit }) => {
//   const validation = useFormik({
//     enableReinitialize: true, // ✅ Allows prefilling when taxData changes
//     initialValues: {
//       id: taxData?.id || "",
//       name: taxData?.name || "",
//       taxPerc: taxData?.taxPerc || "",
//       taxType: taxData?.taxType || "",
//       cgst: taxData?.cgst || "",
//       sgst: taxData?.sgst || "",
//     },
//     validationSchema: Yup.object({
//       name: Yup.string().required("Tax name is required"),
//       taxPerc: Yup.number()
//         .typeError("Tax percentage must be a number")
//         .min(0, "Cannot be negative")
//         .max(100, "Cannot exceed 100%")
//         .required("Tax percentage is required"),
//       cgst: Yup.number()
//         .typeError("CGST must be a number")
//         .min(0, "Cannot be negative")
//         .max(100, "Cannot exceed 100%")
//         .required("CGST percentage is required"),
//       sgst: Yup.number()
//         .typeError("SGST must be a number")
//         .min(0, "Cannot be negative")
//         .max(100, "Cannot exceed 100%")
//         .required("SGST percentage is required"),
//     }),
//     onSubmit: (values) => {
//       const updatedTax = { ...values };
//       onSubmit(updatedTax);
//       toggle();
//     },
//   });

//   useEffect(() => {
//     if (!isOpen) validation.resetForm();
//   }, [isOpen]);

//   return (
//     <Modal isOpen={isOpen} toggle={toggle} centered fade>
//       <ModalHeader toggle={toggle} className="bg-light">
//         Edit Tax
//       </ModalHeader>

//       <Form onSubmit={validation.handleSubmit}>
//         <ModalBody>
//           <FormGroup>
//             <Label for="name">
//               Tax Name <span className="text-danger">*</span>
//             </Label>
//             <Input
//               id="name"
//               name="name"
//               type="text"
//               placeholder="Enter tax name"
//               onChange={validation.handleChange}
//               onBlur={validation.handleBlur}
//               value={validation.values.name}
//               invalid={validation.touched.name && !!validation.errors.name}
//             />
//             <FormFeedback>{validation.errors.name}</FormFeedback>
//           </FormGroup>

//           <FormGroup>
//             <Label for="taxPerc">
//               Tax Percentage (%) <span className="text-danger">*</span>
//             </Label>
//             <Input
//               id="taxPerc"
//               name="taxPerc"
//               type="number"
//               placeholder="Enter total tax percentage"
//               onChange={validation.handleChange}
//               onBlur={validation.handleBlur}
//               value={validation.values.taxPerc}
//               invalid={
//                 validation.touched.taxPerc && !!validation.errors.taxPerc
//               }
//             />
//             <FormFeedback>{validation.errors.taxPerc}</FormFeedback>
//           </FormGroup>

//           <FormGroup>
//             <Label for="taxType">
//               Tax Type <span className="text-danger">*</span>
//             </Label>
//             <Input
//               id="taxType"
//               name="taxType"
//               type="select"
//               onChange={validation.handleChange}
//               onBlur={validation.handleBlur}
//               value={validation.values.taxType}
//               invalid={
//                 validation.touched.taxType && !!validation.errors.taxType
//               }
//             >
//               <option value="">Select Tax Type</option>
//               <option value="CGST">CGST</option>
//               <option value="SGST">SGST</option>
//               <option value="IGST">IGST</option>
//               <option value="C&SGST">C&SGST</option>
//             </Input>
//             <FormFeedback>{validation.errors.taxType}</FormFeedback>
//           </FormGroup>

//           <FormGroup>
//             <Label for="cgst">
//               CGST (%) <span className="text-danger">*</span>
//             </Label>
//             <Input
//               id="cgst"
//               name="cgst"
//               type="number"
//               placeholder="Enter CGST percentage"
//               onChange={validation.handleChange}
//               onBlur={validation.handleBlur}
//               value={validation.values.cgst}
//               invalid={validation.touched.cgst && !!validation.errors.cgst}
//             />
//             <FormFeedback>{validation.errors.cgst}</FormFeedback>
//           </FormGroup>

//           <FormGroup>
//             <Label for="sgst">
//               SGST (%) <span className="text-danger">*</span>
//             </Label>
//             <Input
//               id="sgst"
//               name="sgst"
//               type="number"
//               placeholder="Enter SGST percentage"
//               onChange={validation.handleChange}
//               onBlur={validation.handleBlur}
//               value={validation.values.sgst}
//               invalid={validation.touched.sgst && !!validation.errors.sgst}
//             />
//             <FormFeedback>{validation.errors.sgst}</FormFeedback>
//           </FormGroup>
//         </ModalBody>

//         <ModalFooter>
//           <Button color="secondary" className="btn-sm" onClick={toggle}>
//             Cancel
//           </Button>
//           <Button color="success" className="btn-sm" type="submit">
//             Save changes
//           </Button>
//         </ModalFooter>
//       </Form>
//     </Modal>
//   );
// };

// export default EditTaxModal;

import React, { useEffect } from "react";
import {
  Modal,
  ModalHeader,
  ModalBody,
  ModalFooter,
  Form,
  FormGroup,
  Label,
  Input,
  Button,
  FormFeedback,
} from "reactstrap";
import { useFormik } from "formik";
import * as Yup from "yup";

const EditTaxModal = ({ isOpen, toggle, taxData, onSubmit }) => {
  const validation = useFormik({
    enableReinitialize: true,
    initialValues: {
      id: taxData?.id || "",
      name: taxData?.name || "",
      taxType: taxData?.taxType || "",
      igst: taxData?.igst || "",
      cgst: taxData?.cgst || "",
      sgst: taxData?.sgst || "",
      taxPerc: taxData?.taxPerc || "",
    },

    validationSchema: Yup.lazy((values) =>
      Yup.object({
        name: Yup.string().required("Tax name is required"),
        taxType: Yup.string().required("Tax type is required"),

        // IGST validation
        igst:
          values.taxType === "IGST"
            ? Yup.number()
                .typeError("IGST must be a number")
                .required("IGST is required")
                .min(0)
                .max(100)
            : Yup.number().nullable(),

        // CGST validation
        cgst:
          values.taxType === "C&SGST"
            ? Yup.number()
                .typeError("CGST must be a number")
                .required("CGST is required")
                .min(0)
                .max(100)
            : Yup.number().nullable(),

        // SGST validation
        sgst:
          values.taxType === "C&SGST"
            ? Yup.number()
                .typeError("SGST must be a number")
                .required("SGST is required")
                .min(0)
                .max(100)
            : Yup.number().nullable(),

        taxPerc: Yup.number()
          .typeError("Tax percentage must be a number")
          .required("Total tax percentage is required"),
      })
    ),

    onSubmit: (values) => {
      const payload = {
        id: values.id,
        name: values.name,
        taxType: values.taxType,
        taxPerc: values.taxPerc,
        igst: values.taxType === "IGST" ? values.igst : null,
        cgst: values.taxType === "C&SGST" ? values.cgst : null,
        sgst: values.taxType === "C&SGST" ? values.sgst : null,
      };

      onSubmit(payload);
      toggle();
      validation.resetForm();
    },
  });

  // Auto-calc logic (same as Add modal)
  useEffect(() => {
    const { taxType, igst, cgst } = validation.values;

    if (taxType === "IGST") {
      validation.setFieldValue("cgst", 0);
      validation.setFieldValue("sgst", 0);
      validation.setFieldValue("taxPerc", igst || "");
    }

    if (taxType === "C&SGST") {
      validation.setFieldValue("sgst", cgst || "");
      const total = cgst ? Number(cgst) * 2 : "";
      validation.setFieldValue("taxPerc", total);
    }
  }, [
    validation.values.taxType,
    validation.values.igst,
    validation.values.cgst,
  ]);

  useEffect(() => {
    if (!isOpen) validation.resetForm();
  }, [isOpen]);

  return (
    <Modal isOpen={isOpen} toggle={toggle} centered fade>
      <ModalHeader toggle={toggle} className="bg-light">
        Edit Tax
      </ModalHeader>

      <Form onSubmit={validation.handleSubmit}>
        <ModalBody>
          {/* Tax Name */}
          <FormGroup>
            <Label>
              Tax Name <span className="text-danger">*</span>
            </Label>
            <Input
              id="name"
              name="name"
              type="text"
              placeholder="Enter tax name"
              onChange={validation.handleChange}
              onBlur={validation.handleBlur}
              value={validation.values.name}
              invalid={validation.touched.name && !!validation.errors.name}
            />
            <FormFeedback>{validation.errors.name}</FormFeedback>
          </FormGroup>

          {/* Tax Type */}
          <FormGroup>
            <Label>
              Tax Type <span className="text-danger">*</span>
            </Label>
            <Input
              id="taxType"
              name="taxType"
              type="select"
              onChange={validation.handleChange}
              onBlur={validation.handleBlur}
              value={validation.values.taxType}
              invalid={
                validation.touched.taxType && !!validation.errors.taxType
              }
            >
              <option value="">Select Tax Type</option>
              <option value="IGST">IGST</option>
              <option value="C&SGST">CGST & SGST</option>
            </Input>
            <FormFeedback>{validation.errors.taxType}</FormFeedback>
          </FormGroup>

          {/* IGST Field */}
          {validation.values.taxType === "IGST" && (
            <FormGroup>
              <Label>
                IGST (%) <span className="text-danger">*</span>
              </Label>
              <Input
                id="igst"
                name="igst"
                type="number"
                placeholder="Enter IGST percentage"
                onChange={validation.handleChange}
                onBlur={validation.handleBlur}
                value={validation.values.igst}
                invalid={validation.touched.igst && !!validation.errors.igst}
              />
              <FormFeedback>{validation.errors.igst}</FormFeedback>
            </FormGroup>
          )}

          {/* CGST / SGST Fields */}
          {validation.values.taxType === "C&SGST" && (
            <>
              <FormGroup>
                <Label>
                  CGST (%) <span className="text-danger">*</span>
                </Label>
                <Input
                  id="cgst"
                  name="cgst"
                  type="number"
                  placeholder="Enter CGST percentage"
                  onChange={validation.handleChange}
                  onBlur={validation.handleBlur}
                  value={validation.values.cgst}
                  invalid={validation.touched.cgst && !!validation.errors.cgst}
                />
                <FormFeedback>{validation.errors.cgst}</FormFeedback>
              </FormGroup>

              <FormGroup>
                <Label>
                  SGST (%) <span className="text-danger">*</span>
                </Label>
                <Input
                  id="sgst"
                  name="sgst"
                  type="number"
                  placeholder="Enter SGST percentage"
                  onChange={validation.handleChange}
                  onBlur={validation.handleBlur}
                  value={validation.values.sgst}
                  invalid={validation.touched.sgst && !!validation.errors.sgst}
                />
                <FormFeedback>{validation.errors.sgst}</FormFeedback>
              </FormGroup>
            </>
          )}

          {/* Total Tax */}
          <FormGroup>
            <Label>
              Total Tax (%) <span className="text-danger">*</span>
            </Label>
            <Input
              id="taxPerc"
              name="taxPerc"
              type="number"
              value={validation.values.taxPerc}
              readOnly
            />
          </FormGroup>
        </ModalBody>

        <ModalFooter>
          <Button color="secondary" className="btn-sm" onClick={toggle}>
            Cancel
          </Button>
          <Button color="success" className="btn-sm" type="submit">
            Save Changes
          </Button>
        </ModalFooter>
      </Form>
    </Modal>
  );
};

export default EditTaxModal;
